import { db } from "@/utils/firebase";
import { query, collection, getDocs, where } from "firebase/firestore";

const getAllRequestsCount = async () => {
  try {
    // References to the collections
    const buyerRequestsRef = collection(db, "buyer_requests");
    const sellerRequestsRef = collection(db, "seller_requests");

    // Queries for both buyer and seller requests
    const buyerQuery = query(
      buyerRequestsRef,
      where("status", "==", "processing")
    );

    const sellerQuery = query(
      sellerRequestsRef,
      where("status", "==", "processing")
    );

    // Fetch the documents for both collections
    const [buyerSnapshot, sellerSnapshot] = await Promise.all([
      getDocs(buyerQuery),
      getDocs(sellerQuery),
    ]);

    // Use `size` to count documents without loading fields
    const buyerCount = buyerSnapshot.size;
    const sellerCount = sellerSnapshot.size;

    return buyerCount + sellerCount;
  } catch (error) {
    console.error("Error fetching all requests:", error);
    throw new Error("Failed to fetch all requests");
  }
};

export default getAllRequestsCount;
